// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"450ce24e","74":"402113c4","203":"34759e3e","239":"ef7fe7b8","255":"de71f3ab","299":"33feb5c0","351":"88962ab0","623":"4afb0a34","726":"c961ea61","732":"7290c1a9","977":"017beeb8"}[chunkId] + ".chunk.js";
};